import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Grid, Icon, Header, Transition } from 'semantic-ui-react';

class AppHeader extends Component {
	render() {
		const { session, show, linkClick, name, mobileShow } = this.props;
		const isAdmin = session.hasPolicy('admin');

		const hideClose = window.location.pathname.includes('policy/update');

		return (
			<Container className='header'>
				<Grid columns='equal'>
					<Grid.Column textAlign='left' style={{ minWidth: '225px', flexGrow: 1 }}>
						<a href='/' onClick={linkClick}>
							<div className='logo-header' />
						</a>
						{!hideClose && (
							<a href='/' id="closeLink" onClick={linkClick} className={mobileShow && !session.hasPolicy('admin') ? 'mobileShow' : 'mobileHide'}>
								<Icon name='close' size='large' />
							</a>
						)}
					</Grid.Column>
					{session.authenticated && !isAdmin ? (
						<Grid.Column textAlign='right' className={`tablet only computer only icons ${!show.showWelcome ? '' : 'hidden'}`}>
							<Transition visible={show.showPayments} animation='scale' duration={500}>
								<a href='/payments' onClick={linkClick} className='item blue'>
									<Icon name='credit card alternative' size='large' />
									<span className='light'>Payments</span>
								</a>
							</Transition>
							<Transition visible={show.showClaims} animation='scale' duration={500}>
								<a href='/claims' onClick={linkClick} className='item orange'>
									<Icon name='folder open' size='large' />
									<div className='light'>Claims</div>
								</a>
							</Transition>
							<Transition visible={show.showAgency} animation='scale' duration={500}>
								<a href='/agency' onClick={linkClick} className='item gray'>
									<Icon name='home' size='large' />
									<div className='light'>Agency</div>
								</a>
							</Transition>
							<Transition visible={show.showPolicies} animation='scale' duration={500}>
								<a href='/policies' onClick={linkClick} className='item red'>
									<Icon name='list layout' size='large' />
									<div className='light'>Policies</div>
								</a>
							</Transition>
							<Transition visible={show.showProfile} animation='scale' duration={500}>
								<a href='/profile' onClick={linkClick} className='item teal'>
									<Icon name='user' size='large' />
									<div className='light'>Profile</div>
								</a>
							</Transition>
							<Transition visible={show.showLogout} animation='scale' duration={500}>
								<a href='/logout' onClick={linkClick} className='item slate'>
									<Icon name='lock' size='large' />
									<div className='light'>Logout</div>
								</a>
							</Transition>
						</Grid.Column>
					) : (
						''
					)}
					{session.authenticated && show.showWelcome ? (
						<Grid.Column textAlign='right' className='tablet only computer only'>
							<div className='flex welcome justify end'>
								<Header as='h1' className='thin' content='Welcome' />
								<Header as='h1' className='normal' content={name} />
							</div>
							<div className='flex links justify end'>
								<a href='/profile' onClick={linkClick}>
									<Icon name='user' />
									<span className='light'>Profile</span>
								</a>
								<a href='/logout' onClick={linkClick}>
									<Icon name='lock' />
									<span className='light'>Logout</span>
								</a>
							</div>
						</Grid.Column>
					) : (
						''
					)}
				</Grid>
			</Container>
		);
	}
}

AppHeader.propTypes = {
	session: PropTypes.object.isRequired,
	show: PropTypes.object,
	linkClick: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	mobileShow: PropTypes.bool,
};

export default AppHeader;
